import {
    BrandVariants,
    GriffelStyle,
    Theme,
    createDarkTheme,
    createLightTheme,
    makeStyles,
    shorthands,
    themeToTokensObject,
    tokens,
} from '@fluentui/react-components';

export const genesisHealthcareBrandRamp: BrandVariants = {
    10: '#001009',
    20: '#001f12',
    30: '#002d1a',
    40: '#003c23',
    50: '#004a2b',
    60: '#00583f', // Genesis Green - primary color
    70: '#1a6547',
    80: '#33724f',
    90: '#4d7f57',
    100: '#668c5f',
    110: '#809967',
    120: '#99a66f',
    130: '#b3b377',
    140: '#ccc07f',
    150: '#e6cd87',
    160: '#f2d68f',
};

export const genesisHealthcareLightTheme: Theme & { colorMeBackground: string } = {
    ...createLightTheme(genesisHealthcareBrandRamp),
    colorMeBackground: '#e8ebf9',
    // Genesis secondary color for light mode (Genesis Purple)
    colorBrandBackground2: '#5f3844',
    colorBrandForeground2: '#5f3844',
};

export const genesisHealthcareDarkTheme: Theme & { colorMeBackground: string } = {
    ...createDarkTheme(genesisHealthcareBrandRamp),
    colorMeBackground: '#2b2b3e',
    // Genesis secondary color for dark mode (Genesis Orange)
    colorBrandBackground2: '#d85c02',
    colorBrandForeground2: '#d85c02',
};

export const customTokens = themeToTokensObject(genesisHealthcareLightTheme);

export const Breakpoints = {
    small: (style: GriffelStyle): Record<string, GriffelStyle> => {
        return { '@media (max-width: 744px)': style };
    },
};

export const ScrollBarStyles: GriffelStyle = {
    overflowY: 'auto',
    '&:hover': {
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: tokens.colorScrollbarOverlay,
            visibility: 'visible',
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: tokens.colorNeutralBackground1,
            WebkitBoxShadow: 'inset 0 0 5px rgba(0, 0, 0, 0.1)',
            visibility: 'visible',
        },
    },
};

export const SharedStyles: Record<string, GriffelStyle> = {
    scroll: {
        height: '100%',
        ...ScrollBarStyles,
    },
    overflowEllipsis: {
        ...shorthands.overflow('hidden'),
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
};

export const useSharedClasses = makeStyles({
    informativeView: {
        display: 'flex',
        flexDirection: 'column',
        ...shorthands.padding('80px'),
        alignItems: 'center',
        ...shorthands.gap(tokens.spacingVerticalXL),
        marginTop: tokens.spacingVerticalXXXL,
    },
});

export const useDialogClasses = makeStyles({
    surface: {
        paddingRight: tokens.spacingVerticalXS,
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        ...shorthands.overflow('hidden'),
        width: '100%',
    },
    paragraphs: {
        marginTop: tokens.spacingHorizontalS,
    },
    innerContent: {
        height: '100%',
        ...SharedStyles.scroll,
        paddingRight: tokens.spacingVerticalL,
    },
    text: {
        whiteSpace: 'pre-wrap',
        textOverflow: 'wrap',
    },
    footer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        minWidth: '175px',
    },
});
